export const formatRate = (rate: string, currency?: string, unit?: "h" | "d") => {
  if (unit === undefined) {
    return `${rate || 0} ${currency || ""}`;
  } else {
    return `${rate || 0} ${currency ? `${currency}/${unit}` : ""}`;
  }
};
